import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { getAuthData, setAuth } from "../../../services/authService";
import { useFormik } from "formik";
import * as yup from "yup";
import "react-toastify/dist/ReactToastify.css";

// Validation Schema using Yup
const validationSchema = yup.object().shape({
  email: yup
    .string()
    .email("Must be a valid email")
    .required("Email is required."),
  password: yup.string().required("Password is required."),
});

// Login API call
export const postLogin = (data, showToast = true) => {
  axios
    .post("user/login", data)
    .then((res) => {
      console.log(res.data.data);
      setAuth(res.data.data);
      const { role } = getAuthData();
      localStorage.setItem("userRole", role); 

      console.log(role);

      if (showToast) {
        if (role === "club") {
          toast.success("Login successful");
          window.location.href = "/loged-user-home";
        } 
        else if (role === "SuperAdmin") {
  toast.success("Welcome Super Admin");
  window.location.href = "/all-club-courses";
}
else if (role === "golfer") {
          toast.error("You are not authorized to access");
        }
      }
    })
    .catch((err) => {
      console.log(err, "err");
      toast.error(err.response?.data?.errMsg || "An error occurred");
    });
};

const Login = () => {
  const [passwordShown, setPasswordShown] = useState(false);

  // useFormik hook
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    onSubmit: (values) => {
      values.email = values.email.toLowerCase(); // Convert email to lowercase
      postLogin(values);
    },
    validationSchema: validationSchema,
  });

  // Error rendering function
  const renderErrorMessage = (field) =>
    formik.touched[field] && formik.errors[field] ? (
      <div  className="error-msg" style={{ color: "red" }}>{formik.errors[field]}</div>
    ) : null;

  // Toggle password visibility
  const togglePassword = () => setPasswordShown(!passwordShown);

  return (
    <>
      <form className="login__boxs__left" onSubmit={formik.handleSubmit}>
        <div>
          <h2 className="login__box-heading text-jost-sb-22">
            Please enter your credentials
          </h2>
          <ToastContainer />
        </div>

        <div className="email-container">
          <input
            className="form__input-md"
            type="email"
            placeholder="EMAIL"
            name="email"
            {...formik.getFieldProps("email")}
          />
          {renderErrorMessage("email")}
        </div>

        <div className="password-container">
          <input
            className="form__input-md"
            type={passwordShown ? "text" : "password"}
            placeholder="PASSWORD"
            name="password"
            {...formik.getFieldProps("password")}
          />
          <button
            type="button"
            className="show-hide-pass"
            onClick={togglePassword}
            aria-label={passwordShown ? "Hide password" : "Show password"}
          >
            <img
              src={
                passwordShown
                  ? require("../../../assets/images/password_img/show.svg")
                      .default
                  : require("../../../assets/images/password_img/hide.svg")
                      .default
              }
              alt="Password toggle icon"
            />
          </button>
          {renderErrorMessage("password")}
        </div>

        <div className="main-login-fgt-pass">
          
          <button type="submit" className="res-btn-primary">
            SIGN IN
          </button>
          <NavLink to="/forget-password" className="text-ops-rg-15">
            FORGOTTEN YOUR PASSWORD?
          </NavLink>
        </div>
      </form>
    </>
  );
};

export default Login;
